export default "__VITE_ASSET__CJ$FEiGe__"